/**
 *
 * Styles for EstimatedDeliveryInfo
 *
 */

import styled from "styled-components";
import { DhlText } from "@dhl-official/react-library";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const EstimatedDeliveryText = styled(DhlText)`
  & > *:is(p, span) {
    color: var(--dui-color-black-500) !important;
    margin-top: 0.2rem !important;
    margin-bottom: 1.1rem !important;

    @media screen and (min-width: ${breakpoints.tablet}) {
      margin-top: 0;
      margin-bottom: var(--dui-size-space-1x);
    }
  }
`;

export const DateTimeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: var(--gaq-size-space-5px);
  margin-bottom: var(--gaq-size-space-15px);

  @media screen and (min-width: ${breakpoints.desktop}) {
    line-height: 52px;
    display: block;
    margin-bottom: var(--dui-size-space-4x);
  }
`;
